module.exports = __webpack_public_path__ + "img/HealthInsurance.7d04721f.webp";